import React, { Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
export default function GradingModalWarning({ onHide, onSuccess }) {
  return (
    <Modal
      show={true}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="choice-modal"
      centered>
      <Modal.Header closeButton className="choice-modal-header"></Modal.Header>
      <Modal.Body className="choice-modal-body">
        <h4>Done Grading?</h4>
        <p>
          Are you sure you want to leave? Any activities that have been graded
          but not finalized will lose their grading progress.
        </p>
      </Modal.Body>
      <Modal.Footer className="choice-modal-footer">
        <Button style={{ marginBottom: "12px" }} className="btn get-started" onClick={onSuccess}>
          Done Grading
        </Button>
        <Button className="btn go-back" onClick={onHide}>Go back</Button>
      </Modal.Footer>
    </Modal>
  );
}
